import {
    SHOW_ERROR
} from "../actions/profileActions";

const initialState = {
    typeEror: {
    },
};

const ProfileReducer = (state = initialState, action = {}) => {
    switch (action.type) {
        case SHOW_ERROR:
            return {
                ...state,
                typeError: {
                    message: action.payload.message,
                    type: action.payload.type

                }

            };

        default:
            return state;
    }
};
export default ProfileReducer;
